import { Wine } from '@/shared/models/Wine';

export class Reservation {
    id!: string;
    date?: string;
    quantity!: number;
    status!: string;
    items!: Array<Wine>;
}
